import { RootState, store } from 'duck/store'
import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import SectionLoading from 'scenes/Dashboard/components/SectionLoading'
import { getIsFetchingPeople } from 'scenes/Dashboard/data/people/selectors'

import { Fade, Typography } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

import { AddPersonButton } from './components/AddPersonButton'
import { PeopleTable } from './components/PeopleTable'
import { PeopleTextFilter } from './components/PeopleTextFilter'
import { PersonFormModal } from './components/PersonFormModal'
import { getFilteredPeople, resetSearch } from './duck/actions'
import styles from './PeopleManager.style'

export class PeopleManager extends React.PureComponent<PeopleManagerProps & WithStyles<typeof styles>> {
  render() {
    const { classes } = this.props

    return (
      <Fade in={true}>
        <div>
          <div className={classes.headerContainer}>
            <Typography className={classes.headline}>People Manager</Typography>
            <PeopleTextFilter />
            <AddPersonButton />
          </div>

          {this.body()}
        </div>
      </Fade>
    )
  }

  private body() {
    const { isLoading } = this.props
    if (isLoading) {
      return <SectionLoading />
    }

    return (
      <>
        <PeopleTable />
        <PersonFormModal />
      </>
    )
  }
}

export type PeopleManagerProps = {
  isLoading: boolean
}

function mapStateToProps(state: RootState): StateProps {
  const isFetching = getIsFetchingPeople(state)

  return {
    isLoading: isFetching,
  }
}

type StateProps = Pick<PeopleManagerProps, 'isLoading'>

export default compose<PeopleManagerProps & WithStyles<typeof styles>, {}>(
  lifecycle({
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
      store.dispatch(resetSearch())
      store.dispatch(getFilteredPeople())
    },
  }),
  withStyles(styles),
  connect(mapStateToProps)
)(PeopleManager)
